var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalmese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.1,24.6c-.4.8-.6,1.8-.3,2.6,1,3-.5,4.8-3,5.8-2.7,1.1-5.6,3.2-8.3,1-2.6-2.1-5.7-2.5-8.4-4-2-1.1-4-1.7-6,0-.8.6-.9,0-1.1-.6-.3-1.1-.3-2.3-.3-3.7.2-1.3-.1-2.8-1-4.3-.9-1.5-.9-3.2,0-4.7.4-.6.7-1.3.5-2-1-3.3,1.5-5.6,2.3-8.4.2-.8,1.2-1.1,1.9-1.5,1.2-.5,1.1.7,1.6,1.1.5.3,1,.5,1.5.7,1.7.6,3.5.9,5.2,1.7,1.6.7,3.4.2,4.7-1.1.8-.8,1.5-1.1,2.7-.6,1.6.6,2.5-.5,3.2-1.6.7-1.1,1.1-2.4,1.4-3.7.2-.9.6-2,1.8-.5.8,1,2.8.8,2.8,2.7,0,.8.2,1.5-.2,2.2-.9,1.5-.8,3-.3,4.6,1.4,4.9,1.6,9.7-.8,14.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalmese);
export default __webpack_public_path__ + "static/media/catalmese.c5a3bb057f6083d0e39fe678fc92abb3.svg";
export { ForwardRef as ReactComponent };